module.exports = __webpack_public_path__ + "static/media/parts.4.f7ec1ca8.png";